"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducers = void 0;
var redux_1 = require("redux");
var main_1 = __importDefault(require("./slices/main"));
var basket_1 = __importDefault(require("./slices/basket/basket"));
var user_1 = __importDefault(require("./slices/user"));
var selection_1 = __importDefault(require("./slices/selection"));
exports.reducers = (0, redux_1.combineReducers)({
    //TODO add more as needed
    mainState: main_1.default,
    userState: user_1.default,
    basketState: basket_1.default,
    selectionState: selection_1.default,
});
